export default class Tabs {
	private target: HTMLElement;
	private buttons: NodeListOf<HTMLButtonElement>;
	private tabItems: NodeListOf<HTMLElement>;
	private tabContentItems: NodeListOf<HTMLElement>;

	constructor(target: HTMLElement) {
		this.target = target;

		if (this.validateTabs()) {
			this.buttons = target.querySelectorAll('.tab-navigation li > button');
			this.buttons.forEach((button, index) => {
				if (index === 0) {
					button.classList.add('is-active');
				}
				button.addEventListener('click', () => this.updateTabs(index));
			});
		}
	}

	private validateTabs(): boolean {
		this.tabItems = this.target.querySelectorAll('.tab-navigation li');
		this.tabContentItems = this.target.querySelectorAll('.tab-content > *');

		this.tabContentItems.forEach((item, index) => {
			if (item.querySelectorAll('.wp-block-group__inner-container > *').length === 0) {
				this.tabContentItems[index].remove();
				this.tabItems[index].remove();
			}
		});

		this.tabContentItems = this.target.querySelectorAll('.tab-content > *');
		if (this.tabContentItems.length === 0) {
			this.target.remove();
			return false;
		}

		return true;
	}

	private updateTabs(currentTab: number): void {
		this.buttons.forEach((button, index) => {
			if (index === currentTab) {
				button.classList.add('is-active');
				this.tabContentItems[index].classList.add('is-active');
			} else {
				button.classList.remove('is-active');
				this.tabContentItems[index].classList.remove('is-active');
			}
		});

		this.target.dataset.activeTab = currentTab.toString();
	}
}
